import IconButton from '../../atoms/button/IconButton';
import ButtonUnderlined from '../../atoms/button-underlined/ButtonUnderlined';
import { Icon } from '@iconify/react';
import NotificationList from './NotificationList';
import Card from '../../organisms/Card';
import './NotificationCard.scss';
import { NotificationData } from '../../../types/notification';
import { useState } from 'react';
import clsx from 'clsx';

interface NotificationCardProps {
  notifications: NotificationData[];
  onNotificationRead: (notification: NotificationData) => Promise<void>;
  onMarkAllAsRead: () => void;
  onClose: () => void;
  hidden: boolean;
}

enum Tab {
  UNREAD_NOTIFICATIONS,
  ALL_NOTIFICATIONS,
}

export default function NotificationCard({
  notifications,
  onNotificationRead,
  onMarkAllAsRead,
  onClose,
  hidden,
}: NotificationCardProps) {
  const unreadNotifications = notifications.filter(notification => !notification.read);
  const [activeTab, setActiveTab] = useState<Tab>(Tab.UNREAD_NOTIFICATIONS);

  return (
    <Card className={clsx('notification-card', hidden && 'hidden')}>
      <div className="header">
        <p className="text">Notifications</p>
        <IconButton
          className="close-button"
          icon="close"
          visualType="no-bg"
          iconSize="sm"
          iconColor="red"
          onClick={onClose}
        />
      </div>
      <div className="notification-buttons">
        <div className="underlined-buttons">
          <ButtonUnderlined
            active={activeTab === Tab.UNREAD_NOTIFICATIONS}
            onClick={() => setActiveTab(Tab.UNREAD_NOTIFICATIONS)}
          >
            <div className="underlined-buttons-unread">
              Unread
              <div className="unread-number">{unreadNotifications.length}</div>
            </div>
          </ButtonUnderlined>
          <ButtonUnderlined
            active={activeTab === Tab.ALL_NOTIFICATIONS}
            onClick={() => setActiveTab(Tab.ALL_NOTIFICATIONS)}
          >
            All notifications
          </ButtonUnderlined>
        </div>
        <button className="tick-button" onClick={onMarkAllAsRead}>
          <Icon icon={'mdi:tick-all'} />
          Mark all as read
        </button>
      </div>
      <NotificationList
        notifications={(() => {
          switch (activeTab) {
            case Tab.ALL_NOTIFICATIONS:
              return notifications;
            case Tab.UNREAD_NOTIFICATIONS:
              return unreadNotifications;
          }
        })()}
        onNotificationRead={onNotificationRead}
      />
    </Card>
  );
}
